export const getWorkingDays=(calendarConfig)=>{
    let result = [];
    if (calendarConfig?.workingDays){
       
        
        let data = calendarConfig?.workingDays;
        data.forEach((data) => {
            result.push(data.day);
        })
    }
    return result;
}